import { Panel } from '@scout/ui/shell'
import { createFileRoute } from '@tanstack/react-router'

import { Companies } from '@/corpus/Companies'
import { ProductReading } from '@/corpus/ProductReading'

export const Route = createFileRoute('/admin/products/$productId')({ component: ProductPage })

/**
 * A product's reading, in the panel beside the table it was opened from.
 *
 * The same slot the brief occupies in the product, and for the same reason:
 * what is in the panel is context for what is in the main column. An operator
 * judging whether two dimensions are one wants the list still in front of them
 * while they read the evidence for one product.
 */
function ProductPage() {
  const { productId } = Route.useParams()

  return (
    <>
      <Companies />
      <Panel>
        <ProductReading productID={productId} />
      </Panel>
    </>
  )
}
